<template>
  <footer class="site-footer">
    <div class="footer-inner">
      <nav class="footer-nav">
        <router-link to="/">{{ $t('layout.footer.home') }}</router-link>
        <router-link to="/contact">{{ $t('layout.footer.contact') }}</router-link>
        <router-link to="/terms">{{ $t('layout.footer.terms') }}</router-link>
        <router-link to="/privacy">{{ $t('layout.footer.privacy') }}</router-link>
      </nav>

      <div class="footer-partners" v-if="partners.length">
        <span class="fp-label">{{ $t('layout.footer.partners') }}</span>
        <a
          v-for="(p, i) in partners"
          :key="p.id"
          :href="p.websiteUrl || '#'"
          target="_blank"
          rel="noopener"
          class="fp-link"
        >{{ p.name }}<span v-if="i < partners.length-1" class="fp-dot">·</span></a>
      </div>

      <div class="footer-bottom">
        <span class="footer-disclaimer">{{ $t('layout.footer.disclaimer') }}</span>
        <span class="footer-copy">&copy; {{ year }} onltool.site</span>
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener" class="footer-icp">皖ICP备2026017917号</a>
      </div>
    </div>
  </footer>
</template>

<script>
import { getPartners } from '@/api/site'

export default {
  data() {
    return { year: new Date().getFullYear(), partners: [] }
  },
  created() { this.loadPartners() },
  methods: {
    loadPartners() {
      getPartners().then(res => {
        this.partners = (res.data || []).filter(p => p.enabled)
      }).catch(() => { this.partners = [] })
    }
  }
}
</script>

<style scoped>
.site-footer {
  position: relative;
  background: linear-gradient(180deg, #0f172a 0%, #0b1120 100%);
  color: #64748b;
  font-size: 13px;
  overflow: hidden;
}
.site-footer::before {
  content: '';
  position: absolute; top: 0; left: 0; right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(99, 102, 241, 0.25), rgba(168, 85, 247, 0.25), transparent);
}

.footer-inner {
  max-width: 800px;
  margin: 0 auto;
  padding: 48px 32px 36px;
  text-align: center;
}

.footer-nav {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 32px;
  margin-bottom: 24px;
}
.footer-nav a {
  color: #94a3b8;
  font-size: 13px;
  font-weight: 500;
  text-decoration: none;
  transition: color 0.2s;
}
.footer-nav a:hover { color: #e2e8f0; }

.footer-partners {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
}
.fp-label {
  color: #475569;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-right: 10px;
}
.fp-link {
  color: #64748b;
  font-size: 12px;
  text-decoration: none;
  transition: color 0.2s;
}
.fp-link:hover { color: #94a3b8; }
.fp-dot { color: #334155; margin: 0 4px; }

.footer-bottom {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 14px;
  font-size: 12px;
  color: #475569;
}

.footer-disclaimer {
  color: #5b6b82;
}
.footer-copy {
  color: #475569;
}
.footer-icp {
  color: #4b5b72;
  text-decoration: none;
  transition: color 0.2s;
}
.footer-icp:hover { color: #94a3b8; }
</style>
